/**
 * @generated SignedSource<<1befe8f19029db3d13d3db0f91ed8593>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopBar_viewer$data = {
  readonly offerVisibilityFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"AccountNav_viewer" | "CartNav_viewer" | "DisplaySettingsModal_viewer" | "Likes_viewer" | "Notifications_initialViewer" | "Notifications_viewer" | "OfferVisibility_viewer" | "SearchBar_viewer">;
  readonly " $fragmentType": "TopBar_viewer";
};
export type TopBar_viewer$key = {
  readonly " $data"?: TopBar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopBar_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CartNav_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Likes_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Notifications_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Notifications_initialViewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SearchBar_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AccountNav_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DisplaySettingsModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OfferVisibility_viewer"
    },
    {
      "alias": "offerVisibilityFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "offerVisibilityIndicator"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"offerVisibilityIndicator\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8fb20c3625a97a0abf42e834c2b8142d";

export default node;
